module.exports = __webpack_public_path__ + "img/logistics-trajectory-order.04982d48.svg";